import React from "react";
import ctl from "@netlify/classnames-template-literals";
import TwitterIcon from "svgs/twitter.svg";
import InstagramIcon from "svgs/instagram.svg";
import LinkedinIcon from "svgs/linkedin.svg";
import MediumIcon from "svgs/medium.svg";
import YoutubeIcon from "svgs/youtube.svg";
import { PLink } from "components";

const Socials = () => {
  return (
    <div className={iconWrapStyle}>
      {socialMedia.map(social => {
        return (
          <PLink href={{ url: social.url }} key={social.name}>
            {social.icon}
          </PLink>
        );
      })}
    </div>
  );
};

const iconStyle = ctl(`
fill-secondary-800
w-6
`);

const socialMedia = [
  {
    name: "twitter",
    icon: <TwitterIcon className={iconStyle} />,
    url: "https://twitter.com/ParkwayNG",
  },
  {
    name: "linkedin",
    icon: <LinkedinIcon className={iconStyle} />,
    url: "https://www.linkedin.com/company/parkwayng/",
  },
  {
    name: "instagram",
    icon: <InstagramIcon className={iconStyle} />,
    url: "http://instagram.com/parkway.ng",
  },
  {
    name: "medium",
    icon: <MediumIcon className={iconStyle} />,
    url: "https://medium.com/parkway-projects",
  },
  {
    name: "youtube",
    icon: <YoutubeIcon className={iconStyle} />,
    url: "https://www.youtube.com/channel/UCswfhwbozfvF4paYjf4oVhg",
  },
];

const iconWrapStyle = ctl(`
  flex
  gap-4
  mb-4
  md:mt-6
  mt-4
  items-center
`);

export { Socials };
